import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateDistricts } from '@store/slice/districtsSlice'
import { updateNotification, updateData } from '@store/slice/mainSlice'
import { get } from '@util/xhrAPI'
import { useTranslation } from 'react-i18next'
import useDynamicForm from '@hook/useDynamicForm'
import useDeleteButton from '@hook/useDeleteButton'
import { useTheme } from '@table-library/react-table-library/theme'
import { getTheme } from '@table-library/react-table-library/baseline'
import {
  Table,
  Header,
  HeaderRow,
  Body,
  Row,
  HeaderCell,
  Cell,
} from "@table-library/react-table-library/table"
import Alert from '@ui/elements/Alert'
import Div from '@ui/layout/Div'
import Buttons from '@ui/elements/Buttons'

const ListDistricts = () => {
  const { districts } = useSelector(state => state.districts)
  const { mission } = useSelector(state => state.main)
  const theme = useTheme(getTheme())
  const dispatch = useDispatch()
  const toggleDynamicForm = useDynamicForm()
  const deleteButton = useDeleteButton()
  const [t] = useTranslation('common')

  const dataDistricts = { nodes: [] }
  if (districts) {
    dataDistricts.nodes = Object.values(districts)
  }

  const removeDistrict = district => {
    const { id, links } = district
    get(`${import.meta.env.VITE_API_URL}${links.remove}`, response => {
      const { code } = response
      if (code === 200) {
        const district = districts[id]
        const districtsList = { ...districts }
        delete districtsList[id]
        dispatch(updateDistricts({ ...districtsList }))
        dispatch(updateNotification({ type: 'is-success', message: t('messages.removed_successfuly', { title: district.name }) }))
      } else {
        dispatch(updateNotification({ type: 'is-danger', message: t('messages.error_occured') }))
      }
    })
  }

  useEffect(() => {
    get(`${import.meta.env.VITE_API_URL}/api/missions/${mission.id}/districts`, response => {
      const { code, options, districts } = response
      if (code === 200) {
        dispatch(updateDistricts(districts))
        dispatch(updateData({ districts: options }))
      }
    })
  }, [])

  return (
    <Div cssClass='users-list'>
      <Div cssClass='actions-zone'>
        <Buttons buttons={{
          icon: 'icon-add',
          cssClass: 'is-info is-small',
          callback: () => toggleDynamicForm('district', 'districts'),
          text: t('actions.add')
        }}
        />
      </Div>
      <h2 className='zone-title'>{t('titles.districts_list')}</h2>
      {null !== districts && dataDistricts.nodes.length
        ? <>
          <Table data={dataDistricts} theme={theme}>
            {(tableList) => (
              <>
                <Header>
                  <HeaderRow>
                    <HeaderCell>ID</HeaderCell>
                    <HeaderCell>{t('table.Name')}</HeaderCell>
                    <HeaderCell>{t('table.IsActive')}</HeaderCell>
                    <HeaderCell>Actions</HeaderCell>
                  </HeaderRow>
                </Header>
                <Body>
                  {tableList.map(item =>
                    <Row key={item.id} item={item}>
                      <Cell>{item.id}</Cell>
                      <Cell>{item.name}</Cell>
                      <Cell>{item.isActive ? t('labels.yes') : t('labels.no')}</Cell>
                      <Cell className='table-actions'>
                        <Buttons buttons={[
                          {
                            icon: 'icon-create',
                            cssClass: 'is-info is-small',
                            callback: () => toggleDynamicForm('district', 'districts', item)
                          }
                        ]} />
                        {deleteButton(item, item.name, removeDistrict)}
                      </Cell>
                    </Row>
                  )}
                </Body>
              </>
            )}
          </Table>
        </>
        : <Alert type='is-info' message={t('messages.empty_list')} />
      }
    </Div>
  )
}

export default ListDistricts